import { useQueryClient } from "@tanstack/react-query";
import { signOut } from "firebase/auth";
import { useWorkspaceStore } from "@/stores/workspace";
import { auth } from "@/lib/firebase/config";

/** 로그아웃 한 벌. 헤더에서 설정 화면으로 자리를 옮기면서 빼 뒀다 — 두 곳에
 *  복사하면 한쪽만 캐시를 비우는 날이 온다.
 *
 *  순서가 중요하다: 먼저 로그아웃해야 `PrivateRoute` 가 /login 으로 보내면서
 *  보호된 화면이 내려가고, 그 뒤에 캐시를 비워야 토큰 없는 재조회가 안 돈다.
 *  워크스페이스 id 와 응답 캐시를 같이 비우는 이유는 같은 브라우저로 다른
 *  계정이 들어오기 때문이다 — 어드민 여부(`useAdminMe`)는 staleTime 이 무한이라
 *  남겨두면 앞 계정의 판정이 그대로 붙는다. */
export function useLogout(): () => Promise<void> {
  const setWorkspaceId = useWorkspaceStore((s) => s.setWorkspaceId);
  const queryClient = useQueryClient();

  return async () => {
    await signOut(auth);
    setWorkspaceId(null);
    queryClient.clear();
  };
}
